<template>
  <div class="c-header__col-3">
      <img class="c-header__ornament" src="@/assets/imgs/header-ornament.png" />
  </div>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'NavOrnament',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>
